import { SelectItem } from "primeng/api";
import { name_input, address, city, phoneNumber, zipCode, textareaBox, dose_input, number_input, medication_name_input, blockSpecialCharachters, medical_degree, occupation_name_input, float_number } from "../constant/constant";
import { fileType, fileSize } from "../utilities/utilities";
import { ApiResult, PromiseResult } from "./PromiseResult";
import { Appointment_close_otp } from "./appointment";
import { CountrySelectedValue } from "./doctorregistration";
export enum userid_input_types {
    all,
    email,
    phone_number,
}

export enum userid_label {
    "Email Address or Mobile Number*",
    "Email Address*",
    "Mobile Number*",
}

export class Util_Data {
    fileType = fileType;
    fileSize = fileSize;
}
export class utilities {
    util_data: Util_Data = new Util_Data();

    async copy_json(o1, o2) {
        //this code is used for copying a json common keys from o2 to o1
        Object.keys(o1).map(async (e) => {

            if (o2.hasOwnProperty(e)) {
                if (typeof o2[e] != "object") {
                    o1[e] = o2[e];
                }
                else if (typeof o2[e] == "object" && o2[e] != null) {
                    await this.copy_json(o1[e], o2[e]);
                }
            }

        });
    }

    getValue(email: string): string {
        return Boolean(email) ? email : "";
    }

    // if phone number doesnt start with "+" then start with it
    addSignAtStart(number: string): string {
        return Boolean(number) && number[0] != "+" ? "+" + number : number;
    }

    // extract number without phone code
    getPhoneNumber(phone_code: string, number: string): string {
        let phone_number: string = Boolean(number) ? number : "";
        if (Boolean(phone_number)) {
            phone_number = this.addSignAtStart(phone_number).split(phone_code)[1];
        }
        return phone_number || ""; //doctor and ohp able change the country so mismatch of country and phone number;
    }

    fileSave(type: fileType, file: File, object: any, key_name: string) {
        if (file.size > fileSize[type]) file = null;
        switch (type) {
            case fileType.resume: object[key_name] = file;
                break;
            case fileType.photo: object[key_name] = file;
                break;
            case fileType.unique_id: object[key_name] = file;
                break;
            default:
                break;
        }
    }

    removeFile(object: any, key_name: string) {
        object[key_name] = null;
    }

    getEmptyStringChecker(value: string): boolean {
        return (value != null && Boolean(value) && value?.length > 0);;
    }
}

export class REG_EXP {
    readonly name_input: RegExp = name_input;
    readonly medical_degree: RegExp = medical_degree;
    readonly address: RegExp = address;
    readonly city_input: RegExp = city;
    readonly zipCode: RegExp = zipCode;
    readonly phoneNumber: RegExp = phoneNumber;
    readonly number_input: RegExp = number_input;
    readonly textarea: RegExp = textareaBox;
    readonly medication_name_input: RegExp = medication_name_input;
    readonly dose_input: RegExp = dose_input;
    readonly blockSpecialCharachters: RegExp = blockSpecialCharachters;
    readonly occupation_name_input: RegExp = occupation_name_input;
    readonly float_number: RegExp = float_number;
}

export class RecaptchaData {
    recaptcha_Reset: boolean = false;
    recaptcha_value: any = "";

    reset() {
        this.recaptcha_Reset = false;
        setTimeout(() => {
            this.recaptcha_Reset = true;
        }, 1000);
    }
}


export class PasswordInput {
    isPassword: boolean = true;
    tipsPasswordShowed: boolean = false;

    toggleType() {
        this.isPassword = !this.isPassword;
    }
    toggleTips() {
        this.tipsPasswordShowed = !this.tipsPasswordShowed;
    }

}

export class PaginationModel {
    page_no: number;
    records_per_page: number;
}


export class Button_Data {
    is_clicked: boolean;
    name: string;
    icon: string;
    class: string;
}

export class userid_input_data {
    country_codes: SelectItem[] = [];
    selected_country_code: string = "";
    userid_types = userid_input_types;
    userid_labels = userid_label;
    current_userid_type: 0 | 1 | 2 = this.userid_types.email;
    current_input_type: 0 | 1 | 2 = this.userid_types.all;
    userid_value: string = "";
    contact_number: string = "";
    email: string = "";
    is_email: boolean = true;
    toggle_Reset: boolean = true;
    isDisabled: boolean = false;
    countries_code_3: { [key: string]: CountrySelectedValue } = {};
    countries_code_2: { [key: string]: CountrySelectedValue } = {};
    selected_country_acronym: string = "";
    selected_country_data: CountrySelectedValue = new CountrySelectedValue();
    setCurrentType(is_email: boolean) {
        this.is_email = is_email;
        const type: userid_input_types = is_email ? this.userid_types.email : this.userid_types.phone_number;
        this.current_userid_type = type;
        this.current_input_type = type;
    }

    async toggleLoginType(is_email: boolean) {
        // this.isEmailLogin = is_email;
        this.setCurrentType(is_email);
        this.userid_value = "";
        this.contact_number = "";
        this.email = "";
        // this.selected_country_code = "";
        await this.reset();
    }

    async reset() {
        this.toggle_Reset = false;
        await setTimeout(async () => {
            this.toggle_Reset = true;
        }, 1);

    }


    get_userid_type(): number {
        if (this.isInputTypeAll()) {
            if (this.userid_value.length > 0) {
                if (this.isNumericString()) {
                    this.current_userid_type = this.userid_types.phone_number;
                    return this.userid_types.phone_number;
                }
                else {
                    this.current_userid_type = this.userid_types.email
                    return this.userid_types.email;
                }
            }
            else {
                this.current_userid_type = this.userid_types.email
                return this.userid_types.email;
            }
        }
        else {
            this.current_userid_type = this.current_input_type
            return this.current_input_type;
        }
    }

    getLabel(): string {
        return this.userid_labels[this.current_input_type];
    }

    isInputTypeAll() {
        return this.current_input_type === this.userid_types.all;
    }

    isEmail(): boolean {
        return this.is_email;
    }

    isPhoneNumber(): boolean {
        return !this.is_email;

    }

    isNumericString(): boolean {
        for (let i of this.userid_value) {
            if (i < "0" || i > "9")
                return false;
        }
        return true;
    }

    continueButtonCondition(): boolean {
        if (this.isPhoneNumber()) {
            return !!(this.userid_value &&
                this.selected_country_data.acronym);
        }
        else {
            let first_a = this.userid_value.indexOf("@");
            let last_a = this.userid_value.lastIndexOf("@");
            let last_d = this.userid_value.lastIndexOf(".");
            return this.userid_value.length > 0 &&
                first_a > 0 &&
                last_a == first_a &&
                last_d > 0 &&
                last_d > first_a;
        }
    }

    getCompleteUserIdValue(): string {
        if (this.isPhoneNumber()) {
            return this.contact_number;
        }
        else {
            return this.email;
        }
    }

    constructor(input_type?: 0 | 1 | 2) {
        this.current_input_type = input_type;
    }
}

export class OTP_Validate {
    user_guid: string = "";
    token: string;
    retry: boolean = false;
    service_id: string = "";
    next_code: number;
    countdown: string = "";
    can_resend: boolean = false;
    retry_after: Date = new Date();
    current_date: Date = new Date();
    is_password: boolean = false;
}

export class OtpData {
    otp_api_result: ApiResult = new ApiResult(false);
    OTP_validate_api: OTP_Validate = new OTP_Validate();
    constructor(next_code?: number) {
        this.OTP_validate_api.next_code = next_code;
    }
    otp_Close_Case: Appointment_close_otp = new Appointment_close_otp();
}

export class Component_Leave {
    Fu: boolean = false;
    sc: boolean = false;
}

export class TabView_Data {
    max_tab: number = 0;
    min_tab: number = 0;
    selected_tab: number = 0;

    prevTabValue() {
        return Math.max(this.selected_tab - 1, this.min_tab);
    }

    prevTab(prev_tab?: number) {
        if (prev_tab >= 0 && prev_tab >= this.min_tab && prev_tab < this.selected_tab) {
            this.selected_tab = prev_tab;
        }
        else {
            this.selected_tab = this.prevTabValue();
        }
    }
    nextTabValue() {
        return Math.min(this.selected_tab + 1, this.max_tab);
    }

    nextTab(next_tab?: number) {
        if (next_tab >= 0 && next_tab <= this.max_tab && next_tab > this.selected_tab) {
            this.selected_tab = next_tab;
        }
        else {
            this.selected_tab = this.nextTabValue();
        }
    }

    constructor(min: number, max: number) {
        this.min_tab = min;
        this.max_tab = max;
    }
}



export class Form_Data {
    form_data: FormData = new FormData();
    create_form_data(obj: any, form: FormData, namespace: string) {
        let fd = form || new FormData();
        let formKey: string = "";

        for (let property in obj) {

            if (obj.hasOwnProperty(property)) {

                if (namespace) {
                    formKey = namespace + '[' + property + ']';
                } else {
                    formKey = property;
                }
                let value: any = obj[property];
                let type_of: string = typeof value;
                let type_of_object: boolean = type_of === 'object'
                let type_of_string: boolean = type_of === 'string'
                let instance_of_object: boolean = value instanceof Object;
                let instance_of_file: boolean = value instanceof File;
                let instance_of_date: boolean = value instanceof Date;
                let instance_of_array: boolean = value instanceof Array;
                let is_falsy_value: boolean = value != null && value != undefined && ((type_of_string && value != "") || !(type_of_string))

                if (is_falsy_value) {
                    if (type_of_object && !(instance_of_file) && !(instance_of_date)) {


                        let a: number = formKey.lastIndexOf("[");
                        let b: number = formKey.lastIndexOf("]");
                        let a_bool: boolean = a > 0;
                        let b_bool: boolean = b > 0;
                        let c_bool: boolean = b > a;
                        if (a_bool && b_bool && c_bool) {
                            this.create_form_data(value, fd, formKey);
                        }
                        else {
                            this.create_form_data(value, fd, property);
                        }

                    } else {


                        fd.append(formKey, value);
                    }
                }
            }
        }


        return fd;

    };

}

export class GeocoderResponse extends PromiseResult {
    status: string = "";
    error_message: string = "";
    data: google.maps.GeocoderResult[] = [];
    country_code: string;
    country_name: string;

    constructor(status: string, results: google.maps.GeocoderResult[]) {
        super();
        this.status = status;
        this.data = results;
    }
}
